export interface IGeneralSettingsSchema {
    id: string;
    name: string;
    timezone: string;
    photo: string;
    address?: {
        addressLine1: string;
        state: string;
        country: string;
        postalCode: string;
        latitude: string;
        longitude: string;
        addressLine2: string;
        city: string;
    };
    settings?: Record<string, unknown>;
}
